import { useEffect, useState } from 'react'

import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { Category } from '@twisto/api-cms'

import * as styles from '../articles-search-input.styles'

type Props = {
  category: Category | null
}

export const ArticleSearchBreadcrumb = ({ category }: Props) => {
  const [breadcrumbs, setBreadcrumbs] = useState<string[]>([])

  useEffect(() => {
    if (!category) {
      return
    }

    const categories: string[] = []
    let currentCategory: Category | null = category

    while (currentCategory) {
      categories.push(currentCategory.name)
      currentCategory = currentCategory.parent as Category | null
    }

    setBreadcrumbs(categories)
  }, [category])

  return (
    <Typography color="textTertiary" css={styles.breadcrumb} variant="b3">
      {breadcrumbs.map((breadcrumb) => (
        <span key={breadcrumb} css={styles.breadcrumbItem}>
          {breadcrumb}
        </span>
      ))}
    </Typography>
  )
}
